import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            mcatScore: null,
            gpaScore: null,
            scienceGpa: null,
            state: null,
        },
        answers: [],
        schools: [],
        selectedSchools: [],
        results: {},
        finalScore: 0,
        level: 0,
    },
    mutations: {
        setUser(state, user) {
            window.sessionStorage.setItem('user', JSON.stringify(user));
            state.user = user;
        },
        setSchool(state, schools) {
            window.sessionStorage.setItem('schools', JSON.stringify(schools));
            state.schools = schools;
        },
        addSelectedSchool(state, selected) {
            if (checkSchoolNameInArray(state.selectedSchools, selected)) {
                return;
            }

            state.selectedSchools.push(selected);
            window.sessionStorage.setItem(
                'selected',
                JSON.stringify(state.selectedSchools)
            );
        },
        rmSelectedSchool(state, id) {
            let index = state.selectedSchools.findIndex(
                school => school.id === id
            );
            state.selectedSchools.splice(index, 1);
            window.sessionStorage.setItem(
                'selected',
                JSON.stringify(state.selectedSchools)
            );
        },
        setFinalScore(state, score) {
            window.sessionStorage.setItem('score', score);
            state.finalScore = score;
        },
        createOrUpdateAnswer(state, answer) {
            const answerExists = _.find(state.answers, ['id', answer.id]);
            const answerIndex = _.findIndex(state.answers, ['id', answer.id]);
            if (answerExists) {
                state.answers.splice(answerIndex, 1, answer);
            } else {
                state.answers.push(answer);
            }
            window.sessionStorage.setItem(
                'answer',
                JSON.stringify(state.answers)
            );
        },

        setLevel(state, level) {
            state.level = level;
        },

        setFromSession(state) {
            state.user = JSON.parse(window.sessionStorage.getItem('user')) ?? {
                mcatScore: null,
                gpaScore: null,
                scienceGpa: null,
                state: null,
            };

            state.schools =
                JSON.parse(window.sessionStorage.getItem('schools')) ?? [];
            state.states = JSON.parse(window.sessionStorage.getItem('states'));
            state.selectedSchools =
                JSON.parse(window.sessionStorage.getItem('selected')) ?? [];
            state.score = window.sessionStorage.getItem('score');
            state.answers =
                JSON.parse(window.sessionStorage.getItem('answer')) ?? [];
        },

        reset(state) {
            state.user = {
                mcatScore: null,
                gpaScore: null,
                scienceGpa: null,
                state: null,
            };
            state.schools = [];
            state.states = [];
            state.selectedSchools = [];
            state.score = [];
            state.answer = [];
            window.sessionStorage.clear();
        },
    },
    getters: {
        user: state => state.user,
        mcatScore: state => state.user.mcatScore ?? '',
        gpaScore: state => state.user.gpaScore ?? '',
        scienceGpa: state => state.user.scienceGpa ?? '',
        state: state => state.user.state ?? '',
        answers: state => state.answers,
        schools: state => state.schools,
        selectedSchools: state => state.selectedSchools,
        results: state => state.results,
        finalScore: state => state.finalScore,
        level: state => state.level,
    },
    actions: {
        loadSchools(ctx) {
            const localSchools =
                JSON.parse(window.sessionStorage.getItem('schools')) ?? false;
            if (localSchools) {
                ctx.commit('setSchool', localSchools);
                return;
            }

            axios
                .get(`${process.env.VUE_APP_API_BASE}schools`)
                .then(response => {
                    ctx.commit('setSchool', response.data);
                });
        },

        loadFromSession(ctx) {
            ctx.commit('setFromSession');
            ctx.dispatch('loadSchools');
        },

        reset(ctx) {
            ctx.commit('reset');
        },
    },
    modules: {},
});

export const checkSchoolNameInArray = (array, school) => {
    let i = 0;
    while (i < array.length) {
        if (array[i].name === school.name) {
            return true;
        }
        i++;
    }

    return false;
};
